import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useRef, useState } from 'react';
import { groups, clusters } from './groups';
import { useLocation, Link } from 'react-router-dom';
import SearchPanel from './SearchPanel';
import './ResearchGroupHome.css';

export default function ResearchGroupHome(props) {

    return (
        <div id="research-group-home">
            <div className="upper">
                <SearchPanel lang={props.lang}/>
            </div>
            <h1>{props.lang==="hu" ? "Kutatási területek" : "Research fields"}</h1>
            <div className="cluster-container">
                {clusters.map((cl, cix) => <ResearchClusterBox cluster={cl} key={cix} lang={props.lang} />)}
            </div>
        </div>        
    );
}

function ResearchClusterBox(props) {

    const [open, setOpen] = useState(false);
    const list = useRef();
    const location = useLocation();

    return (
    <div className="cluster-box">
        <div className="cluster-box-header"
            onMouseDown={evt => {
                if (!list.current)
                    return;
                list.current.style.maxHeight = open ? 0 : list.current.scrollHeight + "px";
                setOpen(!open);
                evt.stopPropagation();
                evt.preventDefault()
            }}
        >
            <div className="cluster-box-header-pictogram">
                <FontAwesomeIcon icon={props.cluster.faIcon} size="lg" />
            </div>
            <div className="cluster-box-header-text">{props.cluster[props.lang]}</div>
        </div>
        <div className="cluster-box-list" ref={list}>
            <div className="cluster-box-list-decoration"/>
            {groups.filter(gr => gr.cluster.indexOf(props.cluster.id) >= 0).map((gr, gix) => <div className="cluster-box-item" key={gix}>
                {gix===groups.filter(gr => gr.cluster.indexOf(props.cluster.id) >= 0).length-1 && <div className="cluster-box-item-pre-marker-inner"/>} 
                <div className="cluster-box-item-pre-marker">
                </div>
                <div className="cluster-box-item-marker"/>
                <Link to={`/groups/${gr.id}${location.search}`} className="cluster-box-item-text">
                    <div>
                        {gr[props.lang]}
                    </div>
                </Link>
            </div>)}
        </div>
    </div>);
}